<template>
    <div class="signings category-details-tab" data-test="signing">
        <b-card no-body>
            <b-tabs card>
                <b-tab
                    active
                    @click="setActiveData('individual')"
                >
                    <template #title>
                        <div class="d-flex flex-column py-1">
                            <div style="display:inline-block">
                                Individual 
                                <!-- <span class="status-count pending">{{ documentCount.pendingDocumentsCount }}</span> -->
                            </div>
                        </div>
                    </template>
                </b-tab>

                <b-tab
                    @click="setActiveData('entity')"
                >
                    <template #title>
                        <div class="d-flex flex-column py-1" style="padding-right: 25px;">
                            <div style="display:inline-block">
                                Entity
                                <!-- <span class="status-count pending">{{ documentCount.pendingYourDocumentCount }}</span> -->
                            </div>
                        </div>
                    </template>
                </b-tab>
            </b-tabs>

            <index 
                ref="currentDetails"
                :current-details="currentDetails"
                :title="currentCategory.category"
                :is-loading="isLoading"
                :current-active-tab="currentActiveTab"
                :is-scanning="isScanning"
                @view="view"
                @checked="checked"
                @filter="filter"
                @systemScreening="systemScreening"
            />

             <!-- record details view  -->
            <b-modal v-model="isRecordDetailView" centered  size="lg" hide-footer>
                <div class="pb-2">
                    <b-container class="result-details">
                        <div v-for="value in detailViewRecords" :key="value.id">
                             <div v-if="isKeyHasValue(value[Object.keys(value)[0]])">
                                <b-row v-if="isShowRecord(Object.keys(value)[0])" class="text-left border-bottom" style="padding:8px 0px">
                                    <b-col>{{  Object.keys(value)[0] }}</b-col>
                                    <b-col cols="8">
                                        <div v-if="typeof(value[Object.keys(value)[0]]) === 'object'">
                                            <div>
                                                <ul style="padding:0; margin:0; margin-left:9px; list-style-type: circle;">
                                                    <li v-for="(data) in  Object.keys(value[Object.keys(value)[0]])" :key="data">
                                                        <div v-if="typeof(value[Object.keys(value)[0]][data]) === 'object'">
                                                            <li v-for="nestedValue in Object.keys(value[Object.keys(value)[0]][data])" :key="nestedValue">
                                                                {{ value[Object.keys(value)[0]][data][nestedValue] }}
                                                            </li>
                                                        </div>
                                                        <div v-else>
                                                            {{ value[Object.keys(value)[0]][data]}}
                                                        </div>
                                                    </li>
                                                    <!-- <span v-if="Object.keys(value[Object.keys(value)[0]]).length > i+1">, </span> -->
                                                </ul>
                                            </div>
                                        </div>

                                        <div v-else>
                                            {{ value[Object.keys(value)[0]] }}
                                        </div>
                                    </b-col>
                                </b-row>
                             </div>
                        </div>
                    </b-container>
                </div>
            </b-modal>
        </b-card>
    </div>
</template>

<script>
import { BCard, BTabs, BTab, BModal, BContainer, BRow, BCol } from "bootstrap-vue";
import Compliance from "@/models/Compliance";
import { localize }  from "@/localize/categoryRelatedDetailLocalizer";
import { errorToast, successToast } from "@/views/helpers/toast";
import { SYSTEM_CHECKED_SUCCESS } from "@/constants/success";
import { formatDate } from '@/helpers';
import Index from "./Index.vue";
import { SOMETHING_WENT_WRONG } from '@/constants/errors';

export default {
    components: {
        BCard,
        BTabs,
        BTab,
        BModal,
        BContainer,
        BRow,
        BCol,

        Index,
    },

    props: {
        currentCategory: {
            type: Object,
            required: true
        },
    },

    data() {
        return {
            categoryRelatedDetails: [],
            currentDetails: [],
            detailViewRecords:[],
            doNotShow: ['Category', 'Category Id', 'Batch No', 'Id', 'Data Id', 'System Check', 'Unique Id', 'Data Type'],
            currentActiveTab : "individual",
            currentFilter: "check",
            isRecordDetailView: false,
            isLoading: false,
            isScanning: false
        };
    },

    async created()
    {
        this.isLoading = true;
        const data = await Compliance.getCategoryRelatedDetails(this.currentCategory.id);

        this.categoryRelatedDetails = localize(data);
        this.currentDetails = this.categoryRelatedDetails.individuals;

        this.isLoading = false;
    },

    methods: {
        setActiveData(type) {
            this.currentActiveTab = type;
            this.$refs.currentDetails.checkedList = [];
            this.$refs.currentDetails.shouldSelectAll = false;

            if (type === 'entity')
                this.currentDetails = this.categoryRelatedDetails.entities;

            if (type === 'individual')  
                this.currentDetails = this.categoryRelatedDetails.individuals;
        },

        view(data) {
            this.detailViewRecords = [];
            Object.keys(data).forEach(key => {
                const tempStore = {};
                const modifiedKey = key.charAt(0).toUpperCase() + key.slice(1).split(/(?=[A-Z])/).join(' ');
                if(data[key]) {
                    tempStore[modifiedKey] = data[key];
                }
                this.detailViewRecords.push(tempStore);
            });
            this.isRecordDetailView = true;
        },

        checked(data) {
            Compliance.checkedComplianceData(data.id, this.currentActiveTab)
                .then(() => {
                    // eslint-disable-next-line no-param-reassign
                    data.result = "CHECKED";

                    successToast('Checked successfully.');
                })
                .catch(error => {
                    errorToast(SOMETHING_WENT_WRONG);
                    console.log("Error while checking data ", error);
                });
            
        },

        isShowRecord(key) {
            if(this.doNotShow.includes(key))
                return false;
            return true;
        },

        isKeyHasValue(data) {
            if(data && typeof(data) !== 'object') {
                if(data.length)
                    return true;
                return false;
            }
            if(data && typeof(data) === 'object') {
                const tempStore = [];
                Object.keys(data).forEach(key => {
                    if(data[key])
                        tempStore.push(data[key]);
                });
                if(tempStore.length)
                    return true;
            }
            return false;
        },

        filter(filterKey) {
            this.currentDetails = [];
            this.isLoading = true;
            
            this.currentFilter = filterKey;
            if(this.currentActiveTab === 'entity') {
                if(filterKey === 'check')
                    this.currentDetails = this.categoryRelatedDetails.systemCheckedEntities;
                else 
                    this.currentDetails = this.categoryRelatedDetails.systemUncheckedEntities;
            } else if(this.currentActiveTab === 'individual') {
                if(filterKey === 'check')
                    this.currentDetails = this.categoryRelatedDetails.systemCheckedIndividuals;
                else 
                    this.currentDetails = this.categoryRelatedDetails.systemUncheckedIndividuals;
            }
            
            this.isLoading = false;
        },

        systemScreening(records) {
            this.isScanning = true;

            let payload = [];
            if (this.currentActiveTab === 'individual') {
                payload = records.map(record => ({id: record.id, name: `${record.firstName} ${record.secondName}`}));
            } else {
                payload = records.map(record => ({id: record.id, name: record.name}));
            }

            Compliance.scanSelectedRecords(this.currentActiveTab, payload)
                .then(response => {
                    records.forEach(record => {
                        const data = response[record.id];
                        if (data) {
                            // eslint-disable-next-line no-param-reassign
                            record.scannedOn = formatDate(data.scan_on);
                            if (data.companies.length > 0) {
                                // eslint-disable-next-line no-param-reassign
                                record.result = data.companies.map(company => `${company.name} ${company.type}`).join(", ");
                            } else {
                                // eslint-disable-next-line no-param-reassign
                                record.result = "Not found";
                            }

                            this.$refs.currentDetails.checkedList = this.$refs.currentDetails.checkedList.filter(row => row.id !== record.id);
                        }
                    });
                    
                    successToast(SYSTEM_CHECKED_SUCCESS);
                    this.isScanning = false;
                })
                .catch(e => {
                    console.log("Error wile checking entire system", e);
                    this.isScanning = false;
                });
        },
    }
};
</script>

<style>
/* tab design */
    .category-details-tab .nav-tabs .nav-link {
        margin-bottom: -1px;
        border: 1px solid transparent;
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }
    .category-details-tab .nav-tabs .nav-link.active {
        color: #495057;
        background-color: #fff;
        border-color: #dee2e6 #dee2e6 #fff;
    }
    .category-details-tab .card-header-tabs {
        margin-right: -0.625rem;
        margin-left: -0.625rem;
        margin-bottom: -0.75rem;
        border-bottom: 0;
    }
    .category-details-tab .nav-tabs .nav-link.active:after {
        display: none !important;
    }
    .category-details-tab .card-body {
        padding: .5rem;
    }
    .category-details-tab .card-header {
        padding: 0.75rem 1.25rem;
        margin-bottom: 0;
        background-color: rgba(0,0,0,.03);
        border-bottom: 1px solid rgba(0,0,0,.125);
    }

/* status count design */
    .category-details-tab .status-count {
        font-size: 12.4px;
        color: white;
        display: inline-block;
        width: 24px;
        height: 24px;
        border-radius: 50%;
        padding-top: 3.2px;
        text-align: center;
    }
    .category-details-tab .status-count.pending {
        background: #ffc107!important ;
     }

    .category-details-tab .status-count.completed {
        background: #28c76f;
    }

    .modal-open {
        padding:0px!important;
    }
</style>
